/*
 * Numeric Validation
 */
$.formUtils.addValidator({
	name : 'numeric',
	validatorFunction : function(val, $el, conf, language, $form) {
		if(val !== '') {
			var data = $form.data('inputData');
			var dataAttributes = $el.data();
			/* compareWith will contain either numbers against which execute the comparison, or strings that represent field name */
			var compareWith = [];
			var compareWithTypes = [];
			/* executeWhen will contain either numbers against which decide if proceed to comparison, or strings that represent field name */
			var executeWhen = [];
			var executeWhenTypes = [];

			for(d in dataAttributes){
				if(d.indexOf('validationNumeric') == 0){
					if(d.indexOf('validationNumericWhen') == -1){
						var compValue = dataAttributes[d];
						compareWith.push(compValue);
						compareWithTypes.push(d.substring('validationNumeric'.length).toLowerCase());
					} else {
						executeWhen.push(dataAttributes[d]);
						executeWhenTypes.push(d.substring('validationNumericWhen'.length).toLowerCase());
					}
				}
			}

			/* detect if comparison need to be executed */
			var comparisonNeeded = true;
			if(executeWhen.length > 0 && executeWhenTypes.length > 0){
				var thisVal = parseFloat($el.autoNumeric('get'));
				for(var i=0; i < executeWhenTypes.length; i++){
					if($.isNumeric(executeWhen[i])){
						comparisonNeeded = comparisonNeeded && this.compare(thisVal, executeWhen[i], executeWhenTypes[i]);
					} else {
						var $otherField = $('*[data-name="' + executeWhen[i] + '"]', $form);
						if($otherField.exists()){
							var sVal = $otherField.autoNumeric('get');
							if(sVal != ''){
								comparisonNeeded = comparisonNeeded && this.compare(thisVal, parseFloat(sVal), executeWhenTypes[i]);
							}
						}
					}
				}
			}

			/* perform the comparison execution */

			if(comparisonNeeded && compareWith.length > 0 && compareWithTypes.length > 0){
				var thisVal = parseFloat($el.autoNumeric('get'));
				var isValid = true;
				for(var i=0; i < compareWithTypes.length; i++){
					if($.isNumeric(compareWith[i])){
						isValid = isValid && this.compare(thisVal, compareWith[i], compareWithTypes[i]);
					} else {
						var $otherField = $('*[data-name="' + compareWith[i] + '"]', $form);
						if($otherField.exists()){
							var sVal = $otherField.autoNumeric('get');
							if(sVal != ''){
								isValid = isValid && this.compare(thisVal, parseFloat(sVal), compareWithTypes[i]);
							}
						}
					}
					if(!isValid){
						var ov = $.isNumeric(compareWith[i]) ? compareWith[i] : data[compareWith[i]];
						this.errorMessage = xlate('common.validation.badCompareTo.numeric.' + compareWithTypes[i] + '.msg', {thisValue: val, otherValue: ov});
						break; // stop on first comparison error. no reason to continue
					}
				}
				return isValid;
			} else {
				return true; // comparison not needed, data is valid
			}
		}
		return true;
	},
	compare: function(v1, v2, type){
		switch (type) {
		case 'lt':
			return v1 < v2;
		case 'le':
			return v1 <= v2;
		case 'gt':
			return v1 > v2;
		case 'ge':
			return v1 >= v2;
		case 'eq':
			return v1 == v2;
		case 'nq':
			return v1 != v2;
		default:
			return true;
		}
	},
    errorMessage : '',
    errorMessageKey: ''
});
